/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Split_CustomInputs */

const en_us2_plan_split_custom = /** @type {(inputs: Plan_Split_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom split`)
};

const pt_br2_plan_split_custom = /** @type {(inputs: Plan_Split_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divisão personalizada`)
};

const es_419_plan_split_custom = /** @type {(inputs: Plan_Split_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`División personalizada`)
};

const pt_pt2_plan_split_custom = /** @type {(inputs: Plan_Split_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divisão personalizada`)
};

const fr_fr2_plan_split_custom = /** @type {(inputs: Plan_Split_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Répartition personnalisée`)
};

const de_de2_plan_split_custom = /** @type {(inputs: Plan_Split_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eigener Split`)
};

const it_it2_plan_split_custom = /** @type {(inputs: Plan_Split_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Split personalizzato`)
};

/**
* | output |
* | --- |
* | "Custom split" |
*
* @param {Plan_Split_CustomInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_split_custom = /** @type {((inputs?: Plan_Split_CustomInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Split_CustomInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_split_custom(inputs)
	if (locale === "es-419") return es_419_plan_split_custom(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_split_custom(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_split_custom(inputs)
	if (locale === "de-DE") return de_de2_plan_split_custom(inputs)
	if (locale === "it-IT") return it_it2_plan_split_custom(inputs)
	return en_us2_plan_split_custom(inputs)
});
export { plan_split_custom as "plan.split.custom" }